import React from 'react';
import { Popover } from 'freemium-ui';
import { sortBy } from 'lodash';
import Icons from 'components/icons';
import { customAlphabet } from 'nanoid';

import { ACTIVE_OPTIONS } from '../../../constants';
import { StyledStepMenu } from './style';

const nanoid = customAlphabet('1234567890abcdefghiijklmnopqrstuvwxyz_', 5);

const defaultStep: any = {
  text: '',
  type_info: {
    pivot_question: false,
    question_type: 'TEXT',
  },
};

export const getDefaultQuestion = (id: any): any => {
  return {
    ...defaultStep.type_info,
    question_type: id,
    ...(id === 'DROPDOWN' || id === 'MULTI_SELECT'
      ? { choices: [{ position: 0, value: 'Choice 1' }] }
      : {}),
  };
};

const AddNewBlock = ({
  allBlocks,
  setSurveyForm,
  surveyForm,
  disabled,
  setOpen,
}: any) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const lastItem = sortBy(surveyForm?.question_details?.questions, [
    'position',
  ]).pop();

  const addNewBlock = (id: string) => {
    const q = surveyForm?.question_details?.questions || [];
    let lastBlockName = Number(
      allBlocks[allBlocks.length - 1].name.split('_')[1],
    );
    //when we allow blocks reorder, the below logic will fail since it assumes the number in the name of the block denotes its position relative to other elements in the array.
    const newBlockIndexInName =
      allBlocks
        .map((a: any) => Number(a.title.substring(1)) || 0)
        .sort(function (a: number, b: number) {
          return a - b;
        })
        .pop() + 1;

    const questions = [
      ...q,
      {
        name: `Q_${nanoid()}`,
        position: lastItem.position + 1,
        ...defaultStep,
        type_info: {
          ...getDefaultQuestion(id),
          ...(id === 'DROPDOWN' || id === 'CHECKBOX'
            ? {
                driver: !surveyForm?.question_details?.questions.find(
                  (q: any) => q.type_info.driver,
                ),
              }
            : id === 'PARAGRAPH'
            ? {
                comment: !surveyForm?.question_details?.questions.find(
                  (q: any) => q.type_info.comment,
                ),
              }
            : {}),
          meta: {
            block: {
              name: `B_${nanoid()}`,
              title: `Q${newBlockIndexInName}`,
              is_based_on_rating: false,
            },
          },
        },
      },
    ];

    const newBlocks = questions
      ?.reduce((arr: any, q: any) => {
        return [
          ...arr,
          ...(q.type_info?.meta?.block?.name
            ? [
                {
                  ...q.type_info.meta.block,
                  question_names: q.type_info.meta.block?.question_names || [
                    q.name,
                  ],
                  primary_question_name: q.name,
                  type: q.type_info?.question_type,
                  is_deleted: q.type_info.meta.is_deleted,
                  required: q.required,
                },
              ]
            : []),
        ];
      }, [])
      .filter((b: any) => !b.is_deleted);

    setSurveyForm({
      ...surveyForm,
      question_details: {
        ...surveyForm.question_details,
        questions,
      },
    });

    // -1 for index & -1 for TY block
    setOpen(newBlocks.length - 2);
  };

  return (
    <div className="field">
      <div
        className={`add-step ${anchorEl ? 'open' : ''} ${
          allBlocks.length > 9 || disabled ? 'disabled' : ''
        }`.trim()}
        aria-describedby="basic-popover"
        // onClick={addNewBlock}
        onClick={(e: any) => !disabled && setAnchorEl(e.currentTarget)}
      >
        <span>+</span> <div className="btn-label">New Question</div>
      </div>
      <Popover
        id="basic-popover"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <StyledStepMenu style={{ marginTop: '10px' }}>
          {ACTIVE_OPTIONS.map((option: any) => (
            <div
              className="step-option"
              key={option.label}
              onClick={() => addNewBlock(option.id)}
            >
              <Icons
                size="18"
                viewBox={option?.viewBox || '0 0 18 18'}
                fill="none"
                glyph={option?.icon}
              />
              {option.label}
            </div>
          ))}
        </StyledStepMenu>
      </Popover>
    </div>
  );
};

export default AddNewBlock;
